import {
  PROFESSIONAL_ACCESS_ROLES_FETCHED_SUCCESS,
  PROFESSIONAL_ACCESS_ROLES_FETCHED_FAILURE,
} from '../actions/types';

const initialState = 'NONE';

export default function professionalAccessRolesFetchedReducer(
  state = initialState,
  action,
) {
  const { type, payload } = action;
  switch (type) {
    case PROFESSIONAL_ACCESS_ROLES_FETCHED_SUCCESS:
      return payload;
    case PROFESSIONAL_ACCESS_ROLES_FETCHED_FAILURE:
      return 'NONE';

    default:
      return state;
  }
}
